const Avatar = ({alt, src, className}) => {
  return (
    <img alt={alt} src={src} className={className ? className : "w-16 h-16"}/>
  )
}

export default Avatar;